$component-class: 'me-text';
$text-sizes: (large, medium, regular, small, tiny);
$text-weights: (extra-bold, bold, semi-bold, medium, normal, light);
$text-margin-bottom: var(--spacing-md);
$text-font-sizes: (
  large: map-get($font-sizes, xl),
  medium: map-get($font-sizes, lg),
  regular: map-get($font-sizes, md),
  small: map-get($font-sizes, sm),
  tiny: map-get($font-sizes, xs),
);
$text-line-heights: (
  large: map-get($line-heights, md),
  medium: map-get($line-heights, md),
  regular: map-get($line-heights, md),
  small: map-get($line-heights, md),
  tiny: map-get($line-heights, md),
);

p,
.#{$component-class} {
  font-size: map-get($text-font-sizes, regular);
  line-height: map-get($text-line-heights, regular);
}

p {
  margin: 0 0 $text-margin-bottom;
}

#{$component-class}:last-child {
  p,
  .#{$component-class} {
    margin-bottom: 0;
  }
}

@mixin generate-text-classes {
  @each $value in $text-sizes {
    .#{$component-class}--#{$value} {
      font-size: map-get($text-font-sizes, $value);
      line-height: map-get($text-line-heights, $value);
    }
  }
}

@mixin generate-weight-classes {
  @each $value in $text-weights {
    .#{$component-class}--weight-#{$value} {
      font-weight: map-get($font-weights, $value);
    }
  }
}

@mixin generate-align-classes {
  @each $align in $aligns {
    .#{$component-class}--#{$align} {
      text-align: $align;
    }
  }
}

@include generate-align-classes;
@include generate-text-classes;
@include generate-weight-classes;
